<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Tabela de Gateways</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Gateways</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Gateway</th>
                    <th scope="col" class="border-0">Código</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(gateway, index) in gateways" :key="index">
                    <td></td>
                    <td class="text-left">{{ gateway.Name }}</td>
                    <td>
                      {{
                        gateway.Code == undefined ||
                        gateway.Code == "" ||
                        gateway.Code == null
                          ? "-"
                          : gateway.Code
                      }}
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('Gateway', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenGateway($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('Gateway', 'Update')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenGateway($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="
                              !gateway.IsEnabled &&
                              $isAuthorize('Gateway', 'UpdateEnabled')
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              ProcessUpdateRemovedGateway(index, false)
                            "
                          >
                            <i class="fas fa-minus-square mr-2"></i> Desativar
                          </a>
                          <a
                            v-if="
                              gateway.IsEnabled &&
                              $isAuthorize('Gateway', 'UpdateEnabled')
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              ProcessUpdateRemovedGateway(index, true)
                            "
                          >
                            <i class="fas fa-check-square mr-2"></i> Ativar
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      gateways == undefined ||
                      gateways == null ||
                      gateways.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      size="sm"
      id="mFormGateway"
      :title="modalTitle"
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <!-- Description -->
        <ValidationObserver tag="form" ref="validatedGatewayForm">
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Código</label>
              <ValidationProvider v-slot="{ errors, invalid }">
                <d-form-input
                  type="text"
                  v-model="infoGateway.Code"
                  :class="validatedGatewayForm | showValidateError(invalid)"
                  :disabled="isSeeing || pOpened != null"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedGatewayForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Nome</label>
              <ValidationProvider
                rules="required|min:3"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  type="text"
                  v-model="infoGateway.Name"
                  :class="validatedGatewayForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedGatewayForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveGateway()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IsEnabled" :value="null">
            <option :value="true">Ativos</option>
            <option :value="false">Inativos</option>
          </d-select>
        </d-col>

        <d-col md="6" class="form-group">
          <input
            placeholder="Nome"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('Gateway', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo gateway"
      v-on:click="OpenGateway($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import dateField from "../common/date-field";
import { hasValue } from "../../utils/functions.js";
export default {
  name: "gateway",
  data: function () {
    return {
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      modalTitle: "Novo Gateway",
      countFilter: 0,
      filter: {
        Name: null,
        IsEnabled: true,
      },
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      idGateway: 0,
      pOpened: null,
      gateways: [],
      gatewayfilter: [],
      infoGateway: {
        Name: null,
        Code: null,
      },
      isSeeing: false,
      validatedGatewayForm: false,
    };
  },
  components: {
    dateField,
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.GatewayList();
    },
    "pagination.RowsPerPage": function () {
      this.GatewayList();
    },
  },
  mounted() {
    this.GatewayList();
  },
  methods: {
    OpenGateway: function (e, i, view) {
      e.preventDefault();
      this.validatedGatewayform = false;
      this.ResetInfoGateway();

      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.idGateway = this.gateways[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar Gateway";
        this.GetGateway();
      } else if (view == undefined && i == undefined) {
        // Add new
        this.pOpened = null;
        this.isSeeing = false;
        this.modalTitle = "Gateway";
        this.ResetInfoGateway();
      } else {
        // View
        this.pOpened = i;
        this.idGateway = this.gateways[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do Gateway";
        this.GetGateway();
      }
      this.$bvModal.show("mFormGateway");
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.GatewayList();
    },
    ResetFilter: function () {
      this.filter = {
        Code: null,
        IsEnabled: true,
      };
      this.GatewayList();
    },
    ResetInfoGateway: function () {
      this.idGateway = 0;
      this.infoGateway = {
        Name: null,
        Code: null,
      };
    },
    SaveGateway: function () {
      this.validatedGatewayForm = true;

      this.$refs.validatedGatewayForm.validate().then((isValid) => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            this.$store
              .dispatch("AddGateway", this.infoGateway)
              .then(() => {
                this.$makeToast(
                  "O Gateway foi cadastrado com sucesso.",
                  "success",
                  "Gateway cadastrado"
                );
                this.GatewayList();
                this.$bvModal.hide("mFormGateway");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao cadastrar o Gateway",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.$store
              .dispatch("UpdateGateway", this.infoGateway)
              .then(() => {
                this.$makeToast(
                  "O Gateway foi atualizado com sucesso.",
                  "success",
                  "Gateway atualizada"
                );
                this.GatewayList();
                this.$bvModal.hide("mFormGateway");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao atualizar o Gateway.",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    GetGateway: function () {
      if (this.idGateway != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetGateway", { id: this.idGateway })
          .then((response) => {
            this.infoGateway = response;
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao carregar o Gateway",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    GatewayList: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.IsEnabled)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Name": this.filter.Name,
          "Object.IsEnabled": this.filter.IsEnabled,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("GatewayList", { params: data })
        .then((response) => {
          this.gateways = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os Gateways",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ProcessUpdateRemovedGateway: function (index, enabled) {
      let gateway = this.gateways[index];
      this.$makeMsgBox(
        `Você tem certeza que deseja ${enabled ? "ativar" : "desativar"} ${
          gateway.Name
        } (${gateway.Code}) ?`,
        "Confirmar",
        this.UpdateRemovedGateway,
        gateway,
        enabled
      );
    },
    UpdateRemovedGateway: function (gateway, enabled) {
      let label = enabled ? "ativado" : "desativado";
      let gatewayRemoved = {
        Id: gateway.Id,
        IsEnabled: enabled,
      };

      this.$store
        .dispatch("UpdateEnabled", gatewayRemoved)
        .then(() => {
          this.$makeToast(
            `${gateway.Name} foi ${label}`,
            "success",
            `Gateway ${label}`
          );
          this.GatewayList();
          this.$bvModal.hide("mFormGateway");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover o Gateway",
            error
          );
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/gateways.vue